import { render, staticRenderFns } from "./CollaboratorCreateUpdate.vue?vue&type=template&id=0eb14e14&"
import script from "./CollaboratorCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./CollaboratorCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports